<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="ModalBaslik"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
  >
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">

        <qrcode-stream @decode="onDecode" v-if="camera==true"></qrcode-stream>

        <div v-if="FormDurum">
          <el-divider content-position="left">{{ Binaadi }}</el-divider>


          <el-col :span="24">
            <el-form-item label="Bakım" prop="Bakim_id">
              <el-select v-model="Form.Bakim_id" filterable placeholder="Bakım Seçiniz">
                <el-option
                    v-for="item in Bakimlar"
                    :key="item.id"
                    :label="item.adi"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="24">
            <el-form-item label="Açıklama" prop="aciklama">
              <el-input type="textarea" v-model="Form.aciklama" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </div>
      </el-row>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder" :disabled="FormButon">Kaydet</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Camera" :disabled="CameraButon">Qr Okut
      </el-button>
    </div>
  </el-dialog>

</template>

<script>
export default {
  props: ['Durum'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Form: null,
      Bakimlar: null,
      FormHata: {
        Bakim_id: [{required: true, message: "Bakım Seçiniz", trigger: 'blur'}],
      },
      camera: true,
      FormDurum: false,
      FormButon: true,
      CameraButon: true,

      Binaadi: 'A Binası - A Asansörü Bakımı'
    }
  },
  methods: {
    Kapat() {
      this.$emit('Durum')
      this.camera = false
      this.FormDurum = false

    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true

          this.$store.dispatch('Post', {...this.Form, path: 'barcode'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                  this.$emit('Durum')
                  this.camera = false
                  this.FormDurum = false
                  this.$router.push("/bina/" + response.Build_id);
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    },

    onDecode(decodedString) {
      if (decodedString) {
        this.camera = false

        this.$store.dispatch("Get", {path: 'barcode/' + decodedString})
            .then(response => {
                this.Form.Bina_id = response.Data.Bina.id
                this.Form.Asansor_id = response.Data.id
                this.Binaadi = response.Data.Bina.adi + ' Binası - ' + decodedString + ' Nolu Asansör Bakımı'
                this.FormDurum = true
                this.FormButon = false
                this.CameraButon = false
            })
      }
    },

    Camera() {
      this.camera = true
      this.FormButon = true
      this.CameraButon = true
      this.FormDurum = false
    },


  },
  created() {
    this.FormDurum = false
    this.Form = {}
    this.ModalBaslik = 'Asansör Bakımı Yap'
    this.$store.dispatch("Get", {path: 'care'})
        .then(response => {
          this.Bakimlar = response.Data
        })
  },
  watch: {
    Durum: function () {
      this.camera = this.Durum
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/comp/bakim/bakim.vue